import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { contextPath } from 'site';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { FeatureFlag } from './feature-flag';

const apiURL = `${contextPath}/api/v2/`;
const featureFlagURL = `${apiURL}feature-flags`;

@Injectable()
export class FeatureFlagService {
	constructor(private http: Http) {
	}

	isAutoRenewalsTransferCancelAvdbSubscriptionsEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLYADMIN_AUTO_RENEWALS_TRANSFER_CANCEL_AVDB_SUBSCRIPTIONS']);
	}

	isOrgsRolesEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLY_WEB_ORGS_ROLES']);
	}

	isAircraftSetupWizardEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLY_LEGACY_AIRCRAFT_SETUP_WIZARD']);
	}

	isAircraftLogbookEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLY_ENABLE_AIRCRAFT_LOGBOOK']);
	}

	isAvdbNewZealandEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLYGARMIN_AVDB_NEW_ZEALAND']);
	}

	isHerculesConnectivityEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLYGARMIN_ENABLE_HERCULES_CONNECTIVITY'])
	}

	isNewAircraftListPageEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLYGARMIN_ENABLE_NEW_AIRCRAFT_LIST_PAGE']);
	}

	isDealerAccessManagementWizardEnabled() {
		return this.areFeatureFlagsEnabled(['AVC_FLY_ENABLE_DEALER_ACCESS_MANAGEMENT_SETUP_WIZARD']);
	}

	private getFeatureFlags(featureFlagNames: Array<string>): Observable<Array<FeatureFlag>> {
		let params = new HttpParams();
		featureFlagNames.forEach(featureFlagName => {
			params = params.append('featureFlagNames', featureFlagName);
		});

		return this.http.get(`${featureFlagURL}?${params}`)
			.map(res => res.json().map((array: Array<any>) => FeatureFlag.fromJSON(array)))
			.catch(() => Observable.of([])); // Return an empty array on error
	}

	areFeatureFlagsEnabled(featureFlagNames: Array<string>): Observable<boolean> {
		let featureFlags = this.getFeatureFlags(featureFlagNames);
		return featureFlags.map(flags =>
			flags.some(flag => featureFlagNames.some(featureFlagName => flag.feature === featureFlagName && flag.enabled === true)));
	}
}
